const w = window as any;
const challenge = async (action: string): Promise<string> => {
    await recaptchaReady();
    return await w.grecaptcha.execute('6LcrNuUnAAAAAGY7UyAaa2K2hQMID28fIzCP-Gsb', { action });
}

const recaptchaReady = async () => {
    return new Promise<void>((resolve, reject) => {
        w.grecaptcha.ready(() => {
            resolve();
        });
    });
}

export { challenge };